import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import {
  getActiveSection,
  getBreadcrumbs,
  getFeaturedFolderId,
  getParentFolder,
  getSelectedFolder,
  getIsRootFolder,
} from '../../selectors/studio';
import { fetchBreadcrumbs } from '../../actions/studio/page';
import { Props } from './StudioBreadcrumbs';

export type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'isRootFolder'
  | 'selectedFolder'
  | 'parentFolder'
  | 'featuredFolderId'
  | 'breadcrumbs'
  | 'isBusy'
>;
export type DispatchProps = Pick<Props, 'fetchBreadcrumbs'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const breadcrumbs = getBreadcrumbs(state);
  return {
    activeSection: getActiveSection(state),
    isRootFolder: getIsRootFolder(state),
    selectedFolder: getSelectedFolder(state)!,
    parentFolder: getParentFolder(state),
    featuredFolderId: getFeaturedFolderId(state),
    breadcrumbs: breadcrumbs?.results,
    isBusy: breadcrumbs?.status === 'busy',
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  fetchBreadcrumbs,
};

export default connect(mapStateToProps, mapDispatchToProps);
